'use client';

import './styles.scss';
import { useState } from 'react';
import DisplayDestinationUrlComponent from '../display-destination-url-component';
import QueryParamErrorComponent from '../query-parameter-error-component';
import { QueryParamError } from '../../lib/validateQueryParams';

interface HeaderProps {
  // errors on any query params, including tracking params that are missing, invalid, duplicated, or deprecated of the redirect url
  queryParamErrors: Map<string, QueryParamError>;
  // should show the query param error message on the interstitial page
  shouldShowQueryParamErrors: boolean;
  // the final destination url to redirect to; most often, this will be the partner url
  destinationUrl: string;
  // whether or not to display the destination url on the page
  shouldDisplayRedirectUrl: boolean;
}

const Header: React.FC<HeaderProps> = ({
  shouldShowQueryParamErrors,
  queryParamErrors,
  shouldDisplayRedirectUrl,
  destinationUrl,
}) => {
  const [isDisplayUrlDismissed, setIsDisplayUrlDismissed] = useState(false);
  const [isErrorMessageDismissed, setErrorMessageDismissed] = useState(false);

  const handleDismiss = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.currentTarget.name === 'dismissDestinationUrlButton') {
      setIsDisplayUrlDismissed(true);
    } else if (event.currentTarget.name === 'dismissQueryParamErrorButton') {
      setErrorMessageDismissed(true);
    }
  };

  return (
    <div className="info-header">
      {shouldShowQueryParamErrors &&
        queryParamErrors.size > 0 &&
        !isErrorMessageDismissed && (
          <div className="query-param-error">
            <QueryParamErrorComponent queryParamErrors={queryParamErrors} />
            <br />
            <button
              type="button"
              name="dismissQueryParamErrorButton"
              className="dismiss-button"
              onClick={handleDismiss}
            >
              Dismiss
            </button>
          </div>
        )}
      {shouldDisplayRedirectUrl && !isDisplayUrlDismissed && (
        <div className="display-destination-url">
          <DisplayDestinationUrlComponent destinationUrl={destinationUrl} />
          <br />
          <button
            type="button"
            name="dismissDestinationUrlButton"
            className="dismiss-button"
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
